import { DependencyList, useEffect, useRef } from 'react';

/**
 * Simulate the React v16 useDidMountEffect
 * @param func
 * @param deps be sure to pass ALL the deps used in your effect
 */
export const useDidMountEffect = (func: Function, deps: DependencyList) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
